<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="520"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:100px;">
      <a-spin :spinning="confirmLoading">
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="桌型名称">
            <a-input placeholder="如：大厅四人桌" v-decorator.trim="['name', validatorRules.name]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最少人数">
            <a-input-number style="width: 100%" :min="1" placeholder="最小可坐人数" v-decorator="['minCapacity', { initialValue: 1 }]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最多人数">
            <a-input-number style="width: 100%" :min="1" placeholder="最大可坐人数" v-decorator="['maxCapacity', { initialValue: 4 }]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="保底消费(元)">
            <a-input-number style="width: 100%" :min="0" :precision="2" placeholder="0 表示无保底" v-decorator="['lowestConsume', { initialValue: 0 }]" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import { tableTypeAdd, tableTypeUpdate } from '@/api/plugin/dining'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'DiningTableTypeModal',
  mixins: [mixinDevice],
  props: {
    storeId: { type: Number, default: null }
  },
  data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        name: {
          rules: [
            { required: true, message: '请输入桌型名称!' },
            { max: 30, message: '长度不能超过 30 个字符', trigger: 'blur' }
          ]
        }
      }
    }
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'name', 'minCapacity', 'maxCapacity', 'lowestConsume'))
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.minCapacity > values.maxCapacity) {
            that.$message.warning('最少人数不能大于最多人数')
            return
          }
          that.confirmLoading = true
          // 后端契约：新增 POST /table-type?storeId（storeId 在 query）+ body；编辑 PUT /table-type/{id}
          let obj
          if (!this.model.id) {
            obj = tableTypeAdd(this.storeId, values)
          } else {
            obj = tableTypeUpdate(this.model.id, values)
          }
          obj.then(res => {
            if (res.code === 200) {
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
<style scoped>
</style>
